import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Logout } from '@app/auth/actions/auth';
import { ResetLanguage } from '@app/core/actions/translations';
import { DictionaryService } from '@app/core/services/dictionary.service';
import { UserService } from '@app/core/services/user.service';
import { getLanguageId } from '@app/core/utils';
import * as LabelActions from '@app/pcs/actions/label';
import { ToggleFullScreen } from '@app/pcs/actions/layout';
import * as fromPcs from '@app/pcs/reducer';
import * as PcsNotificationsActions from '@app/pcs/shared/notifications/store/actions/notifications-actions';
import * as fromNotifications from '@app/pcs/shared/notifications/store/reducer';
import * as fromApp from '@app/reducer';
import { select, Store } from '@ngrx/store';
import { interval, Subscription } from 'rxjs';

@Component({
  templateUrl: './pcs.component.html',
  styleUrls: ['./pcs.component.scss']
})
export class PcsComponent implements OnInit, OnDestroy {
  private store = inject(Store<fromPcs.State>);
  private userService = inject(UserService);
  protected dictionaryService = inject(DictionaryService);
  private readonly NOT_SEEN_FEATURES_INTERVAL = 1000 * 60 * 30; // 30 minutes

  currentUser = this.userService.user;
  pcsDocumentationLink$ = this.store.pipe(select(fromApp.getPcsDocumentationLink));
  mailPcsSupport$ = this.store.pipe(select(fromApp.getMailPcsSupport));
  numberOfNotSeenFeatures$ = this.store.pipe(select(fromNotifications.getNotSeenNewFeaturesNotifications));
  subscription$: Subscription;

  ngOnInit(): void {
    this.store.dispatch(new LabelActions.FetchLabels());
    this.store.dispatch(new PcsNotificationsActions.FetchPcsNotifications());
    this.subscription$ = interval(this.NOT_SEEN_FEATURES_INTERVAL).subscribe(() => this.store.dispatch(new PcsNotificationsActions.FetchPcsNotifications()));
  }

  fullScreenAction() {
    this.store.dispatch(new ToggleFullScreen());
  }

  fullScreen(): boolean {
    return this.userService.getFullScreenMode();
  }

  onLogout() {
    this.store.dispatch(new Logout());
    this.store.dispatch(new ResetLanguage(getLanguageId(this.currentUser)));
  }

  ngOnDestroy() {
    this.subscription$?.unsubscribe();
  }

}
